import api from '../utils/Api'
import _ from 'lodash'
import toast from 'react-hot-toast'

export const updateIncomeDocument = (id: number, form: Object, onSuccess: any, showSuccess = true) => {
  api.request(id ? `account/income-document/${id}` : 'account/income-document', (r,s)=>{
    console.log({r,s})
    if (!s) return

    onSuccess(r)
  }, api.form(form, null), 'PATCH', {showSuccess: showSuccess})
}

/**
 * Batch approve income documents — ยิงทีละ CHUNK_SIZE เพื่อไม่ให้ server รับไม่ไหว
 * Replace implementation with a dedicated API call when backend supports:
 *   POST account/income-document/batch-approve  { items: Array<{id, state}> }
 */
const CHUNK_SIZE = 5

const updateIncomeDocumentAsync = (id: number, state: string): Promise<void> =>
  new Promise((resolve, reject) => {
    api.request(
      `account/income-document/${id}`,
      (_r: any, success: boolean) => {
        if (success) resolve()
        else reject(new Error(`Failed to approve document ${id}`))
      },
      api.form({state}, null),
      'PATCH',
      {showSuccess: false}
    )
  })

export const batchApproveIncomeDocuments = async (
  items: Array<{id: number; state: string}>,
  onSuccess: (results: {success: number; failed: number}) => void,
  onProgress?: (done: number, total: number) => void
) => {
  // Future: replace with single batch endpoint
  // api.request('account/income-document/batch-approve', (_r, s) => { if (s) onSuccess(...) },
  //   api.form({ items }, null), 'POST', { showSuccess: true })

  if (!items.length) {
    onSuccess({success: 0, failed: 0})
    return
  }

  let successCount = 0
  let failedCount = 0

  for (let i = 0; i < items.length; i += CHUNK_SIZE) {
    const chunk = items.slice(i, i + CHUNK_SIZE)
    const results = await Promise.allSettled(
      chunk.map(({id, state}) => updateIncomeDocumentAsync(id, state))
    )
    results.forEach((r) => {
      if (r.status === 'fulfilled') successCount++
      else failedCount++
    })
    onProgress?.(successCount + failedCount, items.length)
  }

  if (failedCount === 0) {
    toast.success(`อนุมัติเอกสารสำเร็จ ${successCount} รายการ`)
  } else {
    toast.success(`อนุมัติสำเร็จ ${successCount} รายการ`)
    toast.error(`อนุมัติไม่สำเร็จ ${failedCount} รายการ`)
  }

  onSuccess({success: successCount, failed: failedCount})
}
